import _createForOfIteratorHelper from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import { getGuanqiaWinData } from '@/api/data';
import DataOptions from "../../../components/timeList/dataOptions.vue";
import VxeTable from "@/components/vxeTable/vxeTable.vue";
import serverList from "../../../components/serverList/serverOptions.vue";
export default {
  components: {
    serverList: serverList,
    DataOptions: DataOptions,
    VxeTable: VxeTable
  },
  data: function data() {
    var h = this.$createElement;
    return {
      tableData: {},
      serverInfo: [],
      dateInfo: [this.$moment().subtract(7, "days").format("YYYY-MM-DD"), this.$moment().format("YYYY-MM-DD")],
      tableColumn: [{
        title: "关卡",
        field: "guanqia_no"
      }, {
        title: "关卡开始角色数",
        field: "start_role"
      }, {
        title: "关卡开始次数",
        field: "start_num"
      }, {
        title: "关卡胜利角色数",
        field: "win_role"
      }, {
        title: "关卡胜利次数",
        field: "win_num"
      }, {
        title: "平均通关次数",
        field: "win_av",
        titleHelp: {
          "content": "平均通关次数 = 关卡开始次数 / 关卡胜利角色数"
        }
      }, {
        title: "通关率",
        field: "win_rate",
        titleHelp: {
          "content": "通关率 = 关卡胜利角色数 / 关卡开始角色数"
        },
        slots: {
          default: function _default(_ref) {
            var row = _ref.row;
            return [h("span", [row.win_rate, "%"])];
          }
        }
      }, {
        title: "平均通关时长",
        field: "win_duration"
      }, {
        title: "平均使用道具次数",
        field: "win_item_times"
      }]
    };
  },
  methods: {
    onSearchBtn: function onSearchBtn() {
      var _this = this;
      var searchInfo = {
        sdate: this.dateInfo[0],
        edate: this.dateInfo[1],
        server_id: this.serverInfo
      };
      searchInfo.server_id = this.serverInfo;
      var _iterator = _createForOfIteratorHelper(searchInfo.server_id),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var serverId = _step.value;
          if (serverId == '0') {
            searchInfo.server_id = [];
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      getGuanqiaWinData(searchInfo).then(function (res) {
        _this.tableData = res.data;
      });
    },
    footDataToFirst: function footDataToFirst() {
      var arr1 = document.getElementsByClassName("vxe-table--footer-wrapper");
      var arr2 = document.getElementsByClassName("vxe-table--body-wrapper");
      if (arr2[0]) {
        arr2[0].parentNode.insertBefore(arr1[0], arr2[0]);
      }
    }
  },
  mounted: function mounted() {
    this.footDataToFirst();
    this.onSearchBtn();
  }
};